<script setup lang="ts">
import { ref, watch } from 'vue'
import useConsentStore from '@scripts/stores/consent-store.js'
import { storeToRefs } from 'pinia'
import Consent from '@components/Consent.vue'

const { id } = defineProps<{
    id: string
}>()

const consentStore = useConsentStore()
const { youtubeEnabled } = storeToRefs(consentStore)

const aspectRatio = ref('16/9')

async function getMetadata() {
    try {
        const metadata = await fetch(
            `https://www.youtube-nocookie.com/oembed?url=https://www.youtube.com/watch?v=${id}`
        ).then((res) => res.json())
        aspectRatio.value = `${metadata.width}/${metadata.height}`
    } catch (e) {
        console.error('Could not get oembed metadata. Does the video exist?')
    }
}

watch(
    () => youtubeEnabled,
    (isEnabled) => {
        if (!isEnabled) return

        getMetadata()
    },
    { immediate: true }
)
</script>

<template>
    <Consent
        :aspect-ratio="aspectRatio"
        :enabled="youtubeEnabled"
        text="Dieses Video wird von YouTube geladen."
        @consent="() => (youtubeEnabled = true)"
    >
        <iframe
            :src="`https://www.youtube-nocookie.com/embed/${id}?enablejsapi=1`"
            allowfullscreen
            title="YouTube Video Player"
            class="w-full"
        ></iframe>
    </Consent>
</template>
